import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
	HomeOutlined,
	CopyrightOutlined,
	FolderOpenOutlined,
	TeamOutlined,
	VideoCameraOutlined,
	SolutionOutlined,
	UserOutlined,
	LogoutOutlined,
} from "@ant-design/icons";
import { Layout, Menu,Button } from "antd";
import { Link } from "react-router-dom";
import './Main.css';
import { useContext } from "react";
import { UserContext } from "../../UserContext";
const { Header, Footer, Sider } = Layout;
const App = ({ children }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { handleLogout } = useContext(UserContext);
	const defaultSelectedKeys = () => {
		const pathname = location.pathname;
		
		const menuItems = [
			"/student/home",
			"/student/profile",
			"/student/courses",
			"/student/feedback",
			"/student/help",
		];

		
		const index = menuItems.findIndex((item) => pathname.includes(item));
		return index !== -1 ? [String(index + 1)] : ["2"];
	};
	const Logout = () => {
		handleLogout();
		navigate("/");
	};

	return (
		<Layout>
			<Sider
				className="side"
				breakpoint="md"
				collapsedWidth="0"
				style={{
					overflow: "auto",
					height: "100vh",
					position: "fixed",
					left: 0,
					top: "80px",
					bottom: 0,
					zIndex: 1,
					background: "var(--color-primary)",
					color: "white",
				}}>
				<div className="demo-logo-vertical"></div>
				<Menu
					mode="inline"
					theme="dark"
					defaultSelectedKeys={defaultSelectedKeys()}
					className="menu">
					<Menu.Item key="1" icon={<HomeOutlined />} className="menu-home">
						<Link to="/student/home">Home</Link>
					</Menu.Item>
					<Menu.Item key="2" icon={<UserOutlined />}>
						<Link to="/student/profile">Profile</Link>
					</Menu.Item>
					
					<Menu.Item key="3" icon={<FolderOpenOutlined />}>
						<Link to="/student/courses">Find Courses</Link>
					</Menu.Item>
					<Menu.Item key="4" icon={<TeamOutlined />}>
						<Link to="/student/feedback">Feedback</Link>
					</Menu.Item>
					<Menu.Item key="5" icon={<CopyrightOutlined />}>
						<Link to="/student/help">Help</Link>
					</Menu.Item>
				</Menu>
			</Sider>
			<Layout>
				<Header className="head">
					<div className="title">LEARN YOUR WAY</div>
					<div
						style={{ display: "flex", alignItems: "center" }}
						className="head-icons">
						<Button type="text" onClick={Logout}>
							<LogoutOutlined />
						</Button>
					</div>
				</Header>
				<div className="content">{ children }</div>
				
			</Layout>
		</Layout>
	);
};
export default App;
